<mat-dialog-content>
  <ng-container *ngTemplateOutlet="congratulationsContent"></ng-container>
</mat-dialog-content>

<ng-template #congratulationsContent>
  <div class="congratulations-detail-container">
    <div class="left-column">
      <h3>{{ data.title }}</h3>
      <p class="description" [innerHTML]="data.body"></p>
      @if (data?.urlLink) {
        <a
          class="no-underline"
          (click)="handleLinkClick($event)"
          [matTooltip]="data?.urlLinkLabel"
          [matTooltipShowDelay]="1000"
          [matTooltipHideDelay]="2000"
          style="cursor: pointer">
          {{ data.urlLinkLabel }}
          <mat-icon [svgIcon]="'chevron_right'" aria-hidden></mat-icon>
        </a>
      }
      @if (data?.points) {
        <p
          ><span class="points-earned">Points earned*: </span><span>+{{ data?.points }}</span></p
        >
      }
      <span class="status-text">*Points, badges, and tiers are updated nightly.</span>
    </div>
    <div class="middle-column">
      @if (data?.badgePath) {
        <img [src]="data?.badgePath" class="tier-activity-badge" width="100%" height="100%" />
      }
    </div>
    <div class="right-column">
      <button
        mat-dialog-close
        class="icon close"
        matTooltip="Close"
        [matTooltipShowDelay]="1000"
        [matTooltipHideDelay]="2000"
        [attr.data-analytics]="dataAnalyticsClose">
        <mat-icon [svgIcon]="'close'" aria-hidden></mat-icon>
      </button>
    </div>
  </div>
</ng-template>
